export function trackQuestionAnswered(
  questionKey,
  answer,
  surveySource = null,
  questionSet = null
) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalSurveyQuestionAnswered',
    data: {
      questionKey,
      answer,
      survey_source: surveySource,
      question_set: questionSet,
    },
  });
}

export function trackBackButtonClicked(questionKey, surveySource = null, questionSet = null) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalBackButtonClicked',
    data: {
      questionKey,
      survey_source: surveySource,
      question_set: questionSet,
    },
  });
}

export function trackIntroductionGetStartedClicked() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalIntroductionGetStartedClicked',
  });
}

export function trackLeadFormWithPasswordLoaded() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'LeadWithPasswordFormLoaded',
  });
}

export function trackSignInClicked() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'LoginClicked',
  });
}

export function trackSignInLinkClicked() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'LoginClicked',
    data: {
      type: 'form',
    },
  });
}

export const trackQuestionViewed = (questionKey, surveySource = null, questionSet = null) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalSurveyQuestionViewed',
    data: {
      questionKey,
      survey_source: surveySource,
      question_set: questionSet,
    },
  });
};

export function trackReturnedToSurvey() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'ReturnedToSurvey',
  });
}

export function trackSurveyReset() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveyReset',
  });
}

export function trackSigninClickFromExistingUserMessage() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupExistingUserSigninClick',
  });
}

export function trackMessageFromExistingUser(location) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupExistingUser',
    data: {
      location,
    },
  });
}
